/* eslint-disable no-else-return */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import { useEffect, useState } from 'react'

import LabelWrapper from '../LabelWrapper'
import Skeleton from '../Skeleton'

const styles = theme => ({
  wrapper: {},
  preview: {
    display: 'flex',
    width: '100%',
    '&.thumb img': {
      maxWidth: '100px',
      maxHeight: '100px',
    },
    '&.small img': {
      maxWidth: '250px',
      maxHeight: '250px',
    },
    '&.large img': {
      maxWidth: '500px',
      maxHeight: '500px',
    },
    '&.full img': {
      maxWidth: '100%',
      height: 'auto',
    },
    '& > div:not(.show-all) .pdf-viewer .pdf-canvas:not(:nth-child(2))': {
      display: 'none',
    },
    '&.align-center': {
      justifyContent: 'center',
    },
    '&.align-right': {
      justifyContent: 'flex-end',
    },
  },
  pager: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > div': {
      flex: 1,
    },
  },
  pagerBtn: {
    minWidth: '36px',
  },
  pagerText: {
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
  },
})

const Preview = ({
  align,
  alt,
  classes,
  className,
  customCol,
  customMargin,
  customPadding,
  disabled,
  errorText,
  fileType,
  fullWidth,
  helperText,
  id,
  isLabelInline,
  isRequired,
  isToolTip,
  label,
  multipleFields,
  noMobile,
  notWrapper,
  noWrap,
  showAllPages,
  size,
  spacing,
  src,
  toolTipIcon,
  toolTipIconColor,
  toolTipIconSize,
  toolTipPosition,
  toolTipText,
  willDelete,
  withBorder,
  withDivider,
  noDoc,
  ...rest
}) => {
  const [status, setStatus] = useState('loading')
  const [FileViewerComponent, setFileViewerComponent] = useState(null)

  useEffect(() => {
    let isMounted = true

    if (typeof window === 'undefined') {
      return () => {
        isMounted = false
      }
    }

    import('react-file-viewer')
      .then(module => {
        if (!isMounted) return
        setFileViewerComponent(() => module.default || module)
      })
      .catch(() => {})

    return () => {
      isMounted = false
    }
  }, [])

  const pageWidth = size => {
    if (size === 'thumb') {
      return 100
    } else if (size === 'small') {
      return 250
    } else if (size === 'large') {
      return 500
    }
    return null
  }

  const handleImageLoaded = () => {
    setStatus('loaded')
  }

  const handleImageError = () => {
    setStatus('error')
  }

  return (
    <LabelWrapper
      className={cn(className, classes.wrapper)}
      customCol={customCol}
      customMargin={customMargin}
      customPadding={customPadding}
      disabled={disabled}
      errorText={errorText}
      fullWidth={fullWidth}
      helperText={helperText}
      id={id}
      isLabelInline={isLabelInline}
      isRequired={isRequired}
      isToolTip={isToolTip}
      label={label}
      multipleFields={multipleFields}
      noMobile={noMobile}
      notWrapper={notWrapper}
      noWrap={noWrap}
      spacing={spacing}
      toolTipIcon={toolTipIcon}
      toolTipIconColor={toolTipIconColor}
      toolTipIconSize={toolTipIconSize}
      toolTipPosition={toolTipPosition}
      toolTipText={toolTipText}
      willDelete={willDelete}
      withBorder={withBorder}
      withDivider={withDivider}
      noDoc={noDoc}
      {...rest}
    >
      {src ? (
        <div className={cn(classes.preview, size, `align-${align}`)}>
          {noDoc ? (
            <p>No documents were uploaded</p>
          ) : (
            // biome-ignore lint/complexity/noUselessFragments: TODO
            <>
              {fileType === 'pdf' ? (
                <div className={cn({ 'show-all': showAllPages })} style={{ width: pageWidth(size) }}>
                  {FileViewerComponent ? <FileViewerComponent filePath={src} fileType="pdf" /> : null}
                </div>
              ) : (
                <>
                  {status === 'loading' && <Skeleton width={pageWidth(size)} height={pageWidth(size)} variant="rect" />}
                  {status === 'error' && <p>There was an error loading the image preview</p>}
                  <img src={src} alt={alt} onLoad={() => handleImageLoaded()} onError={() => handleImageError()} />
                </>
              )}
            </>
          )}
        </div>
      ) : (
        'No preview available'
      )}
    </LabelWrapper>
  )
}

Preview.defaultProps = {
  align: 'left',
  size: 'small',
}

const PreviewComponent = withStyles(styles)(Preview)
PreviewComponent.displayName = 'Preview'
export default PreviewComponent
